import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { provideNativeDateAdapter } from '@angular/material/core';
import {
  ApplicationConfig,
  importProvidersFrom,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';

/**
 * Application providers.
 *
 * - Router with component input binding, so route params and query params arrive as
 *   component `input()`s (e.g. `statementId`, `userId`).
 * - HttpClient with the auth interceptor (Bearer token, 401/403 handling) and DI based
 *   interceptors, which lets the loading bar interceptor show progress for every request.
 */
export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withInterceptors([authInterceptor]), withInterceptorsFromDi()),
    importProvidersFrom(LoadingBarHttpClientModule),
    // Date adapter for the Material date range picker (statement list filter)
    provideNativeDateAdapter(),
  ],
};
